/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "566")
  

// 接口文档



export interface API77046Req {
  
  /** 应用编码 */
  appCode: string;
};



export type API77046Res = {};


// 接口函数 77046 删除应用实例

export interface IUsePostAPI77046Return {
  /** 删除应用实例: 接口请求状态 */
  isAPI77046Loading: boolean;
  /** 删除应用实例: 接口请求返回数据 */
  dataAPI77046: API77046Res;
  /**  删除应用实例: 接口数据请求方法 */
  fetchAPI77046Data: (inputs: API77046Req, config?: YWRequestConfig) => Promise<API77046Res>;
  /** 删除应用实例: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI77046 = ():IUsePostAPI77046Return => {
  let isMount = true;
  const [isAPI77046Loading, setIsAPI77046Loading] = useState(false);
  const [dataAPI77046, setDataAPI77046] = useState<API77046Res>({} as API77046Res);
  const requestUrl = `${basePath}/yoaichat-admin/app/instance/delete`;

  const fetchAPI77046Data = async (inputs: API77046Req, config?: YWRequestConfig): Promise<API77046Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API77046Req>) || {}) as API77046Req;
    
  
    if ( isMount ) {
      setIsAPI77046Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API77046Res>(`${basePath}/yoaichat-admin/app/instance/delete`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI77046(res || {} as API77046Res);
        setIsAPI77046Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI77046Loading(false);
      }
      return false as unknown as API77046Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI77046Loading,
    dataAPI77046,
    fetchAPI77046Data,
    requestUrl,
  }
}

